export const DESTINY_PROTOCOL = "destiny-games://verify-success";

export const DOWNLOAD_URL =
  import.meta.env.VITE_APP_DOWNLOAD_URL || "https://destiny-games.com/download";
